import type { Topic as TopicType } from '@/@types/topic'
import ClickWrapper from '@/components/ClickWrapper'
import { css } from '@emotion/react'
import { isEmpty, partial } from 'lodash-es'
import { AnimatePresence, type HTMLMotionProps, motion } from 'motion/react'

export interface TopicSuggestionsProps extends Omit<HTMLMotionProps<'div'>, 'onSelect'> {
	data: TopicType[]
	onSelect?: (value: TopicType) => void
}

export default function TopicSuggestions({ onSelect, data, ...props }: TopicSuggestionsProps) {
	return (
		<motion.div
			{...props}
			css={css`
				margin-left: 12px;
				padding-left: 12px;
				border-left: 1px solid transparent;
				display: flex;
				align-items: center;
				gap: 12px;
				overflow: auto hidden;

				${!isEmpty(data) &&
				css`
					border-left-color: var(--tint-separator, #dbdbdb);
				`}

				&::-webkit-scrollbar {
					display: none;
				}
			`}
		>
			<AnimatePresence mode="popLayout">
				{data.map((item, index) => (
					<ClickWrapper
						initial={{
							opacity: 0,
						}}
						animate={{
							opacity: 1,
							transition: {
								delay: index * 0.05,
							},
						}}
						exit={{
							opacity: 0,
						}}
						key={item.id}
						onClick={onSelect && partial(onSelect, item)}
						css={css`
							border-radius: 15px;
							background: var(--bg-on-body-2, #f0f3f5);
							padding: 4px 8px;
							white-space: nowrap;
							color: var(--tint-secondary, #808080);

							/* Body 5 */
							font-size: 12px;
							line-height: 18px; /* 150% */
						`}
					>
						{item.content}
					</ClickWrapper>
				))}
			</AnimatePresence>
		</motion.div>
	)
}
